//export default 'http://localhost:5001';
//export default 'http://15.188.87.92:5001';
export default 'https://api.caupamat.imperiatec.com';
// export default 'https://hagd-admin.imperiatec.com';
